import React from 'react'
import env from './../../../../environments/environment'
import './LeadershipAndStory.component.scss'

const LeadershipAndStory = () => {
  return (
    <section className='leadership-story'>
      <div className='leadership-story__inner'>
        <div className='leadership-story__photo-col'>
          <img
            src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fwebsite%2Fimg.rick-and-jessica-headshot-new.jpeg?alt=media`}
            alt='Rick and Jessica Banville smiling in matching blue USABG polo shirts in front of an American flag.'
            width='345'
            height='460'
            className='leadership-story__photo'
          />
        </div>
        <div className='leadership-story__text-col'>
          <p className='leadership-story__paragraph'>
            <span>
              Over the years, USABG became known for developing high-performing agents and teams across the country,
              particularly within the under-65 (U65) health insurance market.
            </span>
          </p>
          <p className='leadership-story__paragraph leadership-story__paragraph--spacer'>
            <span>
              <br />
            </span>
          </p>
          <p className='leadership-story__paragraph'>
            <span>
              Before purchasing the company in 2020, Rick and Jessica Banville were already independent agents with
              USABG for many years. Both excelled in personal production and built top national producing teams,
              establishing themselves as respected leaders within the organization.
            </span>
          </p>
          <p className='leadership-story__paragraph leadership-story__paragraph--spacer'>
            <span>
              <br />
            </span>
          </p>
          <p className='leadership-story__paragraph'>
            <span>
              In 2020, Rick and Jessica acquired USA Benefits Group, ushering in a new era of growth, innovation, and
              agent-focused leadership.
            </span>
          </p>
          <a href='/careers' target='_blank' rel='noopener noreferrer' className='leadership-story__button'>
            <span className='leadership-story__button-icon' aria-hidden='true'></span>
            <span className='leadership-story__button-text'>Join Our Agency</span>
          </a>
        </div>
      </div>
    </section>
  )
}

export default LeadershipAndStory
